export default "__VITE_ASSET__DPkON6we__"